import * as React from 'react'
import styled from 'styled-components'
import map from 'ramda/src/map'
import { PrimaryTitle, SectionContainer, ModuleContentContainer } from '../shared/section'
import HeaderLinkBox from './HeaderLinkBox'
import { BASE_BREAKPOINTS } from '../../../utils/enhancers/withResponsive'
import { getZoneName } from '../../zone-helper'

export const HeaderLinkBoxList = styled.ul`
  display: flex;
  list-style: none;
  text-align: center;
  margin-top: 0;
  justify-content: space-around;
  padding-left: 0;
  margin-left: -12px;
  margin-right: -12px;

  @media screen and (max-width: ${BASE_BREAKPOINTS.md}px) {
    flex-direction: column;
    padding: 0 12px;
  }
`

export const getHeaderLinkBoxContainers = map(headerLinkBox => <HeaderLinkBox key={headerLinkBox.tag} headerLinkBox={headerLinkBox} />)

const HeaderLinkBoxModule = ({ zone, headerLinkBoxes }) => (
  <SectionContainer data-testid="section-container-pp">
    <PrimaryTitle data-testid="primary-title-pp">
      Selon votre projet, retrouvez
      <br /> tout l&apos;immobilier {getZoneName(zone, 'charniereC')}
    </PrimaryTitle>
    <ModuleContentContainer data-testid="module-content-pp">
      <HeaderLinkBoxList>{getHeaderLinkBoxContainers(headerLinkBoxes)}</HeaderLinkBoxList>
    </ModuleContentContainer>
  </SectionContainer>
)

export default HeaderLinkBoxModule
